import React, { Component } from "react";


class AddPartnerEvent extends Component {
    render() {
        return (
            <h1>Add Partners View Event Component</h1>
        )
    }
}
export default AddPartnerEvent;
